import { render, staticRenderFns } from "./GalleryCardMenu.vue?vue&type=template&id=5501e7c0&scoped=true&lang=html"
var script = {}
import style0 from "./GalleryCardMenu.vue?vue&type=style&index=0&id=5501e7c0&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5501e7c0",
  null
  
)

export default component.exports